import React from "react";
import { Typography } from "@mui/material";

export default function Copyright() {
  return (
    <Typography data-testid={"copyright"} variant={"caption"} color={"textSecondary"} align={"center"}>
      Copyright &copy; MindSet {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
